/**
 * Created by r4zi4l on 04.05.2022
 */

const OfferManager = function () {
    this.offers = {};
    this.inactiveOffersData = {};

    cleverapps.flags.on("change:monetization", this.refreshProductOffers.bind(this));

    cleverapps.paymentsHistory.onAddPaymentListeners.offermanager = this.refreshByPayerLevel.bind(this);

    this.shownOfferTypes = {};
    this.pendingWindowShowTime = 0;
};

OfferManager.prototype.initialize = function () {
    this.inited = true;

    let data = cleverapps.dataLoader.load(DataLoader.TYPES.OFFERS);
    if (!data) {
        data = this.loadFromOldFormat();
    }

    this.migratePacksData(data);

    this.inactiveOffersData = this._expandData(data) || {};

    Object.keys(Offers.offersByEvent).forEach((event) => {
        cleverapps.eventBus.on(event, () => this.startEventOffers(event));
    });

    cleverapps.abExperiments.whenGroupsUpdated(() => {
        this.refreshAll();

        this.refreshByPayerLevel(true);
    });
};

OfferManager.prototype.loadFromOldFormat = function () {
    const data = {};

    for (const name in Offers.TYPES) {
        const type = Offers.TYPES[name];
        const savedPurchaseTime = cleverapps.dataLoader.load(DataLoader.TYPES.OFFER_PURCHASE_TIME + type);
        if (savedPurchaseTime) {
            data[type] = {
                finished: savedPurchaseTime
            };
        }
    }

    return data;
};

OfferManager.prototype.migratePacksData = function (data) {
    const oldData = cleverapps.dataLoader.load(DataLoader.TYPES.PACK);
    if (data[Offers.TYPES.PACK] || !oldData || !oldData.used) {
        return;
    }

    data[Offers.TYPES.PACK] = {
        stage: oldData.used
    };
};

OfferManager.prototype.updateInfo = function (data) {
    for (const type in this.offers) {
        this.removeOffer(Number(type), true);
    }
    this.offers = {};
    this.inactiveOffersData = this._expandData(data) || {};
    this.refreshAll();
    this.save(true);
};

OfferManager.prototype.save = function (fromServer) {
    cleverapps.dataLoader.save(DataLoader.TYPES.OFFERS, this.getInfo());
    if (!fromServer) {
        connector.synchronizer.addSendTask("offers");
    }
};

OfferManager.prototype.getInfo = function () {
    const activeOffersData = {};
    for (const type in this.offers) {
        activeOffersData[type] = this.offers[type].getInfo();
    }

    const fullData = { ...this.inactiveOffersData, ...activeOffersData };
    return this._compactData(fullData);
};

OfferManager.prototype.reset = function () {
    for (const type in this.offers) {
        this.removeOffer(Number(type), true);
    }
    this.offers = {};
    this.inactiveOffersData = {};
    this.save();
};

OfferManager.prototype.startEventOffers = function (event) {
    const offers = Offers.offersByEvent[event];
    if (!offers) {
        return;
    }

    for (const offerData of offers) {
        if (this.isOfferAvailable(offerData.type, event) && !this.offers[offerData.type]) {
            if (offerData.pendingWindow) {
                this.pendingWindowShowTime = 0;
            }

            this.addOffer(offerData.type);

            return;
        }
    }
};

OfferManager.prototype.refreshAll = function () {
    for (const name in Offers.TYPES) {
        this.refreshOffer(Offers.TYPES[name]);
    }

    for (const type in this.offers) {
        this.offers[type].checkCompletion();
    }

    for (const activeOfferType in this.offers) {
        const activeOfferName = this.offers[activeOfferType].name;
        cleverapps.playSession.logEventOnce(cleverapps.EVENTS.OFFER_DAU, {
            itemId: activeOfferName,
            key: `${cleverapps.EVENTS.OFFER_DAU}_${activeOfferName}`
        });
    }
};

OfferManager.prototype.refreshProductOffers = function () {
    for (const name in Offers.TYPES) {
        const offerType = Offers.TYPES[name];

        if (Offers[offerType] && (Offers[offerType].product || Offers[offerType].productByPayerLevel || Offers[offerType].productByStage)) {
            this.refreshOffer(offerType);
        }
    }
};

OfferManager.prototype.refreshOffer = function (offerType, event) {
    if (!Offers[offerType]) {
        return;
    }

    if (this.isOfferAvailable(offerType, event)) {
        if (this.offers[offerType]) {
            this.offers[offerType].refresh();
        } else {
            this.addOffer(offerType);
        }
    } else if (this.offers[offerType]) {
        this.removeOffer(offerType);
    }
};

OfferManager.prototype.addOffer = function (offerType) {
    const offer = new Offer(offerType, this.inactiveOffersData[offerType]);

    delete this.inactiveOffersData[offerType];
    this.offers[offerType] = offer;

    if (offer.fresh) {
        cleverapps.metrics.logEvent(cleverapps.EVENTS.OFFER_START, { itemId: offer.name });
    }

    this.save();

    this.addOfferIcon(offer);
};

OfferManager.prototype.removeOffer = function (offerType, fromServer) {
    const offer = this.offers[offerType];
    offer.beforeRemove();

    this.inactiveOffersData[offerType] = offer.getInfo();
    delete this.offers[offerType];

    if (!fromServer) {
        this.save();
    }

    this.removeOfferIcon(offer, fromServer);
};

OfferManager.prototype.addOfferIcon = function (offer) {
    if (Offers[offer.type] && Offers[offer.type].noSideBarIcon) {
        return;
    }

    if (cleverapps.extraBar && offer.extraBarIcon
        && cleverapps.meta.getSelectedLocation().locationConfig.locationType === "merge") {
        if (!cleverapps.extraBar.findOfferIcon(offer)) {
            const icon = new OfferIcon(offer);
            cleverapps.extraBar.addIcon(icon);
        }
        return;
    }

    if (!cleverapps.sideBar.findOfferIcon(offer.type)) {
        const icon = new OfferIcon(offer);
        cleverapps.sideBar.addTemporaryIcon(icon);
    }
};

OfferManager.prototype.removeOfferIcon = function (offer, silent) {
    if (cleverapps.extraBar) {
        const icon = cleverapps.extraBar.findOfferIcon(offer);
        if (icon) {
            cleverapps.extraBar.removeIcon(icon, silent);
        }
    }

    const icon = cleverapps.sideBar.findOfferIcon(offer.type);
    if (icon) {
        cleverapps.sideBar.removeTemporaryIcon(icon);
    }
};

OfferManager.prototype.resetOfferIcon = function (offer) {
    if (cleverapps.extraBar) {
        const icon = cleverapps.extraBar.findOfferIcon(offer);
        if (icon) {
            icon.resetState();
        }
    }

    const icon = cleverapps.sideBar.findOfferIcon(offer.type);
    if (icon) {
        icon.resetState();
    }
};

OfferManager.prototype.refreshByMission = function (missionType, isNew) {
    const offer = Offers.offerByMission[missionType] || Offers.offerByMission[Mission.GetMissionType(missionType)];
    if (offer) {
        this.refreshOffer(offer.type);
        if (this.offers[offer.type] && isNew) {
            this.offers[offer.type].reset();
        }
    }
};

OfferManager.prototype.refreshByLocation = function (locationId) {
    const offers = Offers.offersByLocation[locationId];
    if (offers) {
        offers.forEach((offer) => {
            this.refreshOffer(offer.type);
        });
    }
};

OfferManager.prototype.refreshByHero = function (unit) {
    const offer = Offers.offerByHero[Unit.GetKey(unit)];
    if (offer) {
        this.refreshOffer(offer.type);
    }
};

OfferManager.prototype.refreshByFog = function (fog) {
    const offers = Offers.offersByFog[fog];
    if (offers) {
        offers.forEach((offer) => {
            this.refreshOffer(offer.type);
        });
    }
};

OfferManager.prototype.refreshByPayerLevel = function (recreateAllOffers) {
    const currentPayerLevel = cleverapps.paymentsHistory.classify();

    const payerLevelOffers = [];

    for (const name in Offers.TYPES) {
        const offerType = Offers.TYPES[name];
        const offerData = Offers[offerType];

        if (offerData && (offerData.productByPayerLevel || offerData.rewardByPayerLevel)) {
            payerLevelOffers.push(offerType);
        }
    }

    payerLevelOffers.forEach((offerType) => {
        const currentOffer = this.offers[offerType];

        if (currentOffer) {
            const offerPayerLevel = currentOffer.logic.getPayerLevel();

            if (!currentOffer.logic.isBeingPurchased && (offerPayerLevel !== currentPayerLevel || recreateAllOffers)) {
                this.refreshOffer(offerType);
            }
        }
    });
};

OfferManager.prototype.clearLocationOffers = function (locationId) {
    const offers = Offers.offersByLocation[locationId];
    if (offers && offers.length) {
        offers.forEach((offer) => {
            if (this.offers[offer.type]) {
                this.removeOffer(offer.type);
            }
            if (this.inactiveOffersData[offer.type]) {
                delete this.inactiveOffersData[offer.type];
            }
        });
        this.save();
    }
};

OfferManager.prototype.findOffer = function (options) {
    if (options.type) {
        return this.offers[options.type];
    }

    const product = options.product;
    const mission = options.mission === undefined ? undefined : Mission.GetMissionType(options.mission);

    for (const type in this.offers) {
        const offer = this.offers[type];

        if (product !== undefined && product !== offer.logic.product) {
            continue;
        }

        if (mission !== undefined && (mission !== offer.logic.mission && options.mission !== offer.logic.mission)) {
            continue;
        }

        return offer;
    }
};

OfferManager.prototype.isOfferAvailable = function (offerType, event) {
    const offerData = Offers[offerType];
    let offerInfo = this.inactiveOffersData[offerType] || {};
    if (this.offers[offerType]) {
        offerInfo = this.offers[offerType].getInfo();
        if (offerInfo.finished) {
            return false;
        }
    }

    if (!this.inited || !offerData) {
        return false;
    }

    if (offerData.isAvailable && !offerData.isAvailable(offerInfo)) {
        return false;
    }

    if (offerData.available) {
        if (!levels.user.checkAvailable(offerData.available)) {
            return false;
        }

        if (!cleverapps.paymentsHistory.checkAvailable(offerData.available)) {
            return false;
        }
    }

    if (offerData.schedule) {
        const { startDate, endDate } = MissionManager.parseWeekdayRange(offerData.schedule);
        if (Date.now() < startDate.getTime() || Date.now() >= endDate.getTime()) {
            return false;
        }
    }

    if (offerData.inABExperiments && (!cleverapps.abExperiments.isInitialized() || !offerData.inABExperiments())) {
        return false;
    }

    if (offerInfo.finished && offerData.once) {
        return false;
    }

    if (offerData.mission) {
        const mission = cleverapps.missionManager.findByType(offerData.mission);
        if (!mission || mission.isCompleted()) {
            return false;
        }

        if (!MissionManager.hasProperLocation(offerData.mission)) {
            return false;
        }

        if (offerData.oncePerMission && offerInfo.finished && offerInfo.finished > mission.started) {
            return false;
        }
    } else {
        if (!Product.HasPaymentMethod()) {
            return false;
        }

        if (offerData.feature && !cleverapps.eventManager.isActive(offerData.feature)) {
            return false;
        }

        if (offerData.location && offerData.location !== cleverapps.meta.selectedLocationId()) {
            return false;
        }

        if (!offerData.location && !offerData.anyLocation && !cleverapps.meta.getSelectedLocation().locationConfig.isMain) {
            return false;
        }

        if (!cleverapps.environment.isMainScene() && !cleverapps.environment.isGameScene()) {
            return false;
        }
    }

    if (offerData.debugMode && !cleverapps.config.debugMode) {
        return false;
    }

    if (offerData.hero && (!cleverapps.unitsLibrary || cleverapps.unitsLibrary.isOpened(offerData.hero))) {
        return false;
    }

    const stageProduct = offerData.productByStage && offerData.productByStage[offerInfo.stage || 0];
    const products = [offerData.product, stageProduct, ...(offerData.productByPayerLevel || [])].filter(Boolean);

    if (products.some((product) => !Product.IsPurchasable(product))) {
        return false;
    }

    const notAvailableProducts = products.filter((product) => !connector.payments.getProduct(product));
    if (notAvailableProducts.length) {
        if (cleverapps.config.debugMode && !offerData._loggedMissProducts) {
            offerData._loggedMissProducts = true;
            cleverapps.throwAsync(`Offer ${offerData.name} miss required products: ${notAvailableProducts.join(", ")}`);
        }
        return false;
    }

    if (offerData.fog && (!Map2dLocation.currentLocation || !Map2dLocation.currentLocation.map.fogs.isOpened(offerData.fog))) {
        return false;
    }

    if (offerData.oneOf && offerData.oneOf.some((otherOfferType) => otherOfferType !== offerType && this.offers[otherOfferType])) {
        return false;
    }

    if (offerData.afterEvent && !offerInfo.started) {
        if (!cleverapps.toArray(offerData.afterEvent).includes(event)) {
            return false;
        }
    }

    if (offerData.cooldown && offerInfo.finished && Date.now() <= offerInfo.finished + cleverapps.parseInterval(offerData.cooldown)) {
        return false;
    }

    if (offerData.oncePerLocation && offerData.location && offerInfo.finished) {
        const location = cleverapps.meta.getLocationMeta(offerData.location);
        if (offerInfo.finished > location.getStartTime()) {
            return false;
        }
    }

    if (offerData.availableByStages) {
        const currentStage = offerInfo.stage || 0;
        if (currentStage >= offerData.availableByStages.length || !levels.user.checkAvailable(offerData.availableByStages[currentStage])) {
            return false;
        }
    }

    return true;
};

OfferManager.prototype.showPendingOffer = function () {
    const offer = cleverapps.offerManager.findOfferWithPendingWindow();
    if (offer) {
        cleverapps.offerManager.showOfferWindow(offer);
    }
};

OfferManager.prototype.findOfferWithPendingWindow = function () {
    const fresh = [];
    const pending = [];

    for (const type in this.offers) {
        const offer = this.offers[type];
        if (!offer) {
            continue;
        }

        if (!Offers[type].pendingWindow || this.shownOfferTypes[type]) {
            continue;
        }

        if (offer.fresh) {
            fresh.push(offer);
            continue;
        }

        if (this.pendingWindowShowTime + OfferManager.SHOW_WINDOW_INTERVAL <= Date.now()) {
            pending.push(offer);
        }
    }

    return fresh[0] || pending[0];
};

OfferManager.prototype.showOfferWindow = function (offer) {
    cleverapps.focusManager.display({
        focus: `${offer.name}IconClicked`,
        stack: true,
        action: function (f) {
            this.shownOfferTypes[offer.type] = true;
            this.pendingWindowShowTime = Date.now();

            const WindowCtor = Offers[offer.type].view;
            new WindowCtor(offer);

            cleverapps.focusManager.onceNoWindowsListener = f;

            cleverapps.metrics.logEvent(cleverapps.EVENTS.OFFER_OPEN, { itemId: Offers[offer.type].name });
        }.bind(this)
    });
};

OfferManager.prototype.getOfferExpedition = function (offerType) {
    let locationId = "main";
    const data = Offers[offerType];

    if (data) {
        if (data.location) {
            locationId = data.location;
        } else if (data.mission) {
            locationId = Missions[data.mission] && Missions[data.mission].location || "main";
        }
    }

    return locationId;
};

// An offer "product": the offer's underlying product with the offer's display metadata attached.
// The offer tile prefab renders it; offerData feeds the offer source/controller. Object.create keeps
// the real product's methods (buy / logBuyItem / getIcon) for the buy flow.
OfferManager.makeOfferProduct = function (product, offerData) {
    const offerProduct = Object.create(product);
    offerProduct.prefab = bundles.tile_shop.jsons.offerproducttile_prefab_json;
    offerProduct.offerData = offerData;
    return offerProduct;
};

OfferManager.prototype.getShopProducts = function (tab) {
    tab = tab || ShopWindow.TABS.HARD_CURRENCY;

    if (!cleverapps.environment.isMainScene() && !cleverapps.environment.isGameScene()) {
        return [];
    }
    const products = [];

    for (const type in this.offers) {
        const offer = this.offers[type];
        const shopIcon = Offers[offer.type].shopIcon || offer.name.toLowerCase().replace(/[0-9]/g, "");

        const isHardCurrencyOffer = tab === ShopWindow.TABS.HARD_CURRENCY && bundles.tile_shop.frames[shopIcon] && !Offers[offer.type].shopTab;
        const isTabOffer = Offers[offer.type].shopTab === tab;

        if ((isHardCurrencyOffer || isTabOffer) && offer.logic.isIconAvailable() && offer.logic.getProduct()) {
            const product = offer.logic.getProduct();

            const view = Offers[offer.type].view;

            let title;
            if (Offers[offer.type].title) {
                title = Messages.get(Offers[offer.type].title);
            } else if (view && view.getOfferTitle) {
                title = Messages.get(view.getOfferTitle(offer));
            } else {
                title = Offers[offer.type].mission ? Messages.get(`SingleProductOfferWindow.${offer.name}.title`) : product.title;
            }

            let reward;
            if (Offers[offer.type].rewardByPayerLevel) {
                reward = offer.logic.getRewards();
            } else {
                reward = Offers[offer.type].reward || product.reward;
            }

            products.push(OfferManager.makeOfferProduct(product, {
                offer,
                shopIcon,
                title,
                reward
            }));
        }
    }

    if (cleverapps.specialEnergyOffer) {
        const offerName = !cleverapps.meta.getSelectedLocation().locationConfig.isMain ? "energyofferexp" : "energyoffer";
        if (cleverapps.specialEnergyOffer.getIconLeftTime() > 0 && bundles.tile_shop.frames[offerName]) {
            products.push(OfferManager.makeOfferProduct(cleverapps.specialEnergyOffer.getProduct(), {
                offer: {
                    name: offerName,
                    complete: function () {
                        cleverapps.specialEnergyOffer.refreshAfterBought();
                    },
                    logPurchase: function () {},
                    incStage: function () {}
                },
                shopIcon: offerName,
                title: Messages.get("SpecialEnergyOfferWindow.title"),
                reward: {
                    energy: cleverapps.specialEnergyOffer.getEnergyAmount()
                }
            }));
        }
    }

    return products;
};

OfferManager.prototype._compactData = function (data) {
    const resultData = {};
    for (const type in data) {
        const offer = data[type];
        const offerData = Offers[type];

        const countOfFields = Object.keys(offer).filter((k) => offer[k] !== undefined).length;

        if (countOfFields === 0) {
            continue;
        }

        if (offer.finished && offerData) {
            if (offerData.cooldown && countOfFields === 1 && Date.now() > offer.finished + cleverapps.parseInterval(offerData.cooldown)) {
                continue;
            }
        }

        resultData[type] = {
            s: cleverapps.compactTime(offer.started),
            f: cleverapps.compactTime(offer.finished),
            st: offer.stage,
            l: cleverapps.compactTime(offer.lastRewardTime)
        };
    }

    return resultData;
};

OfferManager.prototype._expandData = function (data) {
    const resultData = {};
    for (const type in data) {
        const offer = data[type];
        if (!offer) {
            continue;
        }
        resultData[type] = {
            started: offer.started || cleverapps.expandTime(offer.s),
            finished: offer.finished || cleverapps.expandTime(offer.f),
            stage: offer.stage || offer.st,
            lastRewardTime: offer.lastRewardTime || cleverapps.expandTime(offer.l)
        };
    }
    
    return resultData;
};

OfferManager.SHOW_WINDOW_INTERVAL = cleverapps.parseInterval("10 minutes");
